import { Schema } from 'effect';
export const Gender = {
    MALE: 'MALE',
    FEMALE: 'FEMALE'
};
export const AllGenderType = [Gender.MALE, Gender.FEMALE];
const _GenderSchema = Schema.Literal(...AllGenderType);
export const GenderSchema = _GenderSchema;
